let list = [];

for (let i = 0; i < 15; i++) {
    list.push({
        id: i + 1,
        no: 'yf001',
        cardNo: Date.now(),
        customerName: '王汇丰',
        mobile: '18888888888',
        amount:'1333元',
        type: i < 5 ? 'in' : 'out',
        remark: '这是一个闷骚的男人'
    });
}

export default {
    list,
    total: list.length,
    pageSize: 15,
    pageNum: 1
}



// WEBPACK FOOTER //
// ./src/configure/http/mock/response/card/queryCardPage.js